import { makeConstantFactory } from 'utils/constantsHelper'
const makeConstant = makeConstantFactory('conversation/message')

export const FETCH_CONVERSATION_MESSAGES = makeConstant('FETCH_CONVERSATION_MESSAGES')
export const FETCH_FIRST_MESSAGES_PENDING = makeConstant('FETCH_FIRST_MESSAGES_PENDING')
export const FETCH_FIRST_MESSAGES_FAILED = makeConstant('FETCH_FIRST_MESSAGES_FAILED')
export const RECEIVE_FIRST_MESSAGES = makeConstant('RECEIVE_FIRST_MESSAGES')

export const FETCH_PAGINATED_CONVERRSATION_MESSAGES = makeConstant('FETCH_PAGINATED_CONVERRSATION_MESSAGES')
export const FETCH_PAGINATED_CONVERRSATION_MESSAGES_PENDING = makeConstant('FETCH_PAGINATED_CONVERRSATION_MESSAGES_PENDING')
export const FETCH_PAGINATED_CONVERRSATION_MESSAGES_FAILED = makeConstant('FETCH_PAGINATED_CONVERRSATION_MESSAGES_FAILED')
export const FETCH_PAGINATED_CONVERRSATION_MESSAGES_CANCELLED = makeConstant('FETCH_PAGINATED_CONVERRSATION_MESSAGES_CANCELLED')
export const RECEIVE_PAGINATED_MESSAGE_LIST = makeConstant('RECEIVE_PAGINATED_MESSAGE_LIST')

export const FETCH_NEXT_PAGINATED_CONVERSATION_MESSAGES = makeConstant('FETCH_NEXT_PAGINATED_CONVERSATION_MESSAGES')
export const FETCH_NEXT_PAGINATED_CONVERSATION_MESSAGES_PENDING = makeConstant('FETCH_NEXT_PAGINATED_CONVERSATION_MESSAGES_PENDING')
export const FETCH_NEXT_PAGINATED_CONVERSATION_MESSAGES_FAILED = makeConstant('FETCH_NEXT_PAGINATED_CONVERSATION_MESSAGES_FAILED')
export const FETCH_NEXT_PAGINATED_CONVERSATION_MESSAGES_CANCELLED = makeConstant('FETCH_NEXT_PAGINATED_CONVERSATION_MESSAGES_CANCELLED')
export const RECEIVE_NEXT_MESSAGE_LIST = makeConstant('RECEIVE_NEXT_MESSAGE_LIST')

export const CREATE_MESSAGE = makeConstant('CREATE_MESSAGE')
export const CREATE_MESSAGE_PENDING = makeConstant('CREATE_MESSAGE_PENDING')
export const CREATE_MESSAGE_FAILED = makeConstant('CREATE_MESSAGE_FAILED')
export const RECEIVE_MESSAGE = makeConstant('RECEIVE_MESSAGE')

export const REMOVE_MESSAGE = makeConstant('REMOVE_MESSAGE')

export const MESSAGE_READ = makeConstant('MESSAGE_READ')
export const MESSAGE_READ_PENDING = makeConstant('MESSAGE_READ_PENDING')
export const MESSAGE_READ_FAILED = makeConstant('MESSAGE_READ_FAILED')
export const MESSAGE_READ_SUCCESS = makeConstant('MESSAGE_READ_SUCCESS') // dummy
export const OPTIMISTIC_MESSAGE_READ_SUCCESS = makeConstant('OPTIMISTIC_MESSAGE_READ_SUCCESS')
export const MARK_MESSAGE_READ_BY_CONVERSATION = makeConstant('MARK_MESSAGE_READ_BY_CONVERSATION')
export const BULK_MESSAGE_READ_SUCCESS = makeConstant('BULK_MESSAGE_READ_SUCCESS')

export const MESSAGE_READ_UNTIL_FAILED = makeConstant('MESSAGE_READ_UNTIL_FAILED')
export const MESSAGE_READ_UNTIL_SUCCESS = makeConstant('MESSAGE_READ_UNTIL_SUCCESS')

export const RECEIVE_MESSAGE_READ = makeConstant('RECEIVE_MESSAGE_READ')

export const NOTIFY_USER = makeConstant('NOTIFY_USER')
export const BROWSER_NOTIFICATION = makeConstant('BROWSER_NOTIFICATION')

export const SELECT_BOT_ACTION = makeConstant('SELECT_BOT_ACTION')

export const FETCH_PLAYBOOK_CONTEXT = makeConstant('FETCH_PLAYBOOK_CONTEXT')
export const LOAD_MORE_MESSAGES = makeConstant('LOAD_MORE_MESSAGES')

export const CREATE_REFETCH_LISTENERS = makeConstant('CREATE_REFETCH_LISTENERS')
export const REFETCH_MESSAGES_COMPLETED = makeConstant('REFETCH_MESSAGES_COMPLETED')

export const MessageStatus = Object.freeze({
  Sent: "Sent",
  Delivered: "Delivered",
  Read: "Read",
})

export const NotifiableMessageTypes = Object.freeze({
  EMAIL: "EMAIL",
  CHAT: "CHAT",
})

export const RECEIVE_BULK_UPDATE_MESSAGES = makeConstant('RECEIVE_BULK_UPDATE_MESSAGES')

export const TYPES_TO_PREVIEW = [
  'EMAIL',
  'SMS',
  'CHAT',
  'PHONE',
  'TWITTER',
  'PRIVATE_NOTE',
  'PRIVATE_PROMPT'
]



// WEBPACK FOOTER //
// ./src/scripts/app/modules/message/constants.js